const PEER_CONFIG = {
  host: process.env.VUE_APP_SIGNALING_HOST,
  port: process.env.VUE_APP_SIGNALING_PORT,
  secure: process.env.NODE_ENV !== 'development',
  iceServers: [
    { 'urls': 'stun:35.78.35.13:80' },
    { 'urls': 'turn:35.78.35.13:80?transport=tcp', 'username': 'ice-bensys','credential': 'D758T0jE9za~YT-U' }
  ]
}

export default PEER_CONFIG
